import { formatShanghaiDateTime } from '../../utils/datetime';

export const statusMap = {
  active: { text: '运行中', color: 'green' },
  paused: { text: '已停用', color: 'orange' },
  completed: { text: '已完成', color: 'blue' },
  failed: { text: '失败', color: 'red' },
};

export const runStatusMap = {
  pending: { text: 'pending', color: 'gold' },
  running: { text: 'running', color: 'gold' },
  success: { text: 'success', color: 'green' },
  failed: { text: 'failed', color: 'red' },
  noop: { text: 'noop', color: 'blue' },
  canceled: { text: 'canceled', color: 'default' },
};

export const taskTypeMap = {
  cron: '定时任务',
  once: '单次任务',
  interval: '间隔任务',
  manual: '手动任务',
};

export const formatDateTime = (dateTimeString) => formatShanghaiDateTime(dateTimeString);

export const formatListField = (value) => {
  if (value === null || value === undefined) return '';
  const items = Array.isArray(value) ? value : [value];
  const text = items
    .filter((item) => item !== null && item !== undefined)
    .map((item) => String(item).trim())
    .filter(Boolean)
    .join(', ');
  return text;
};

export const normalizeList = (value) => {
  if (value === null || value === undefined) return [];
  if (Array.isArray(value)) {
    return value
      .filter((item) => item !== null && item !== undefined)
      .map((item) => String(item).trim())
      .filter(Boolean);
  }
  return String(value).split(',').map((item) => String(item).trim()).filter(Boolean);
};

export const buildTaskSearchParams = (formValues = {}, page = 1, pageSize = 20) => {
  const params = {
    page,
    page_size: pageSize,
    keyword: formValues.keyword || '',
    filters: {},
    sort: { field: 'created_at', order: 'desc' },
  };

  if (formValues.creator_user_id && formValues.creator_user_id.trim()) {
    params.filters.creator_user_id = formValues.creator_user_id.trim();
  }
  if (formValues.creator_user_name && formValues.creator_user_name.trim()) {
    params.filters.creator_user_name = formValues.creator_user_name.trim();
  }
  if (formValues.status && formValues.status.length > 0) {
    params.filters.status = formValues.status;
  }
  if (formValues.task_type && formValues.task_type.length > 0) {
    params.filters.task_type = formValues.task_type;
  }
  if (Object.keys(params.filters).length === 0) {
    delete params.filters;
  }

  return params;
};

export const buildTaskFiltersFromSelection = (selectedFilters = {}) => {
  const filters = {};
  if (!selectedFilters) return filters;

  if (selectedFilters.content_type && selectedFilters.content_type.length > 0) {
    filters.content_types = Array.isArray(selectedFilters.content_type)
      ? selectedFilters.content_type
      : [selectedFilters.content_type];
  }
  if (selectedFilters.source) {
    filters.content_sources = Array.isArray(selectedFilters.source)
      ? selectedFilters.source
      : [selectedFilters.source];
  }
  if (selectedFilters.creator_user_id) {
    filters.creators = [selectedFilters.creator_user_id];
  }
  if (selectedFilters.status && selectedFilters.status.length > 0) {
    filters.status = Array.isArray(selectedFilters.status)
      ? selectedFilters.status
      : [selectedFilters.status];
  }
  if (selectedFilters.risk_flag !== undefined && selectedFilters.risk_flag !== null) {
    filters.risk_flag = selectedFilters.risk_flag;
  }
  if (selectedFilters.is_manual_reviewed !== undefined && selectedFilters.is_manual_reviewed !== null) {
    filters.is_manual_reviewed = selectedFilters.is_manual_reviewed;
  }
  if (selectedFilters.manual_review_required !== undefined && selectedFilters.manual_review_required !== null) {
    filters.manual_review_required = selectedFilters.manual_review_required;
  }
  if (selectedFilters.tags) {
    const tagsArray = typeof selectedFilters.tags === 'string'
      ? selectedFilters.tags.split(',').map((t) => t.trim()).filter(Boolean)
      : selectedFilters.tags;
    if (tagsArray.length > 0) {
      filters.tags = tagsArray;
    }
  }
  if (selectedFilters.available_platforms && selectedFilters.available_platforms.length > 0) {
    filters.available_platforms = Array.isArray(selectedFilters.available_platforms)
      ? selectedFilters.available_platforms
      : [selectedFilters.available_platforms];
  }
  if (selectedFilters.title) {
    filters.title = selectedFilters.title.trim();
  }
  if (selectedFilters.keyword) {
    filters.keyword = selectedFilters.keyword.trim();
  }
  if (selectedFilters.content_id) {
    filters.content_id = selectedFilters.content_id.trim();
  }
  if (selectedFilters.ingested_at_range) {
    const fromDate = selectedFilters.ingested_at_range[0]?.toDate
      ? selectedFilters.ingested_at_range[0].toDate()
      : selectedFilters.ingested_at_range[0];
    const toDate = selectedFilters.ingested_at_range[1]?.toDate
      ? selectedFilters.ingested_at_range[1].toDate()
      : selectedFilters.ingested_at_range[1];
    filters.ingested_at_range = {
      from: fromDate.toISOString(),
      to: toDate.toISOString(),
    };
  }

  return filters;
};
